import { render } from "./editCodeReview.vue?vue&type=template&id=828b51cc&scoped=true"
import script from "./editCodeReview.js?vue&type=script&lang=js"
export * from "./editCodeReview.js?vue&type=script&lang=js"

import "./editCodeReview.vue?vue&type=style&index=0&id=828b51cc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-828b51cc"]])

export default __exports__